import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Button, Image } from 'react-bootstrap';

const SingleProductComp = () => {
    const { productId } = useParams();
    const [product, setProduct] = useState({});

    useEffect(() => {
        const getProduct = async () => {
            const response = await fetch(`https://dummyjson.com/products/${productId}`);
            const respJson = await response.json();
            setProduct(respJson);
        };

        getProduct();
    }, [productId]);

    return (
        <div>
            <section>
                <Container>
                    <div>
                        <div>
                            {product.thumbnail && product.images.length > 0 && <Image src={product.thumbnail} alt={product.title} fluid />}
                            <h1>{product.title}</h1>
                            <p>{product.description}</p>
                            <h3>${product.price}</h3>

                            <div className="mt-3">
                                <Button variant="secondary">Add to Chart</Button> <Button variant="primary">Buy Now</Button>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
        </div>
    );
};

export default SingleProductComp;
